import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import { BootstrapVue,IconsPlugin  } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "UA-90740854-1" },
  pageTrackerTemplate(to) {
    return {
      page_path : to.fullPath,
      page_title: 'Galerie photo - '+to.name
    }
  }
}, router);

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
